/* 
    Document Template request
  {
     app_id: 1,
     item_id: 1
     element_id: 1,
     data: {}
  }

*/

export class DocumentManager {
  constructor(req, pipeService) {
    this.req = req;
    this.pipeService = pipeService;
  }

  createDocument(documentObject) {
    this.emitDocumentInsert(documentObject);
    return this.req.post({
      url: "/api/new/document/insert-one",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      form: { document: JSON.stringify(documentObject) },
    });
  }

  emitDocumentInsert(data) {
    const dataToEmit = typeof data.data === "string" ? JSON.parse(data.data) : data.data;
    this.pipeService.emit("gh_document_insert_one", { app_id: data.app_id, item_id: data.item_id, element_id: data.element_id }, dataToEmit);
  }

  getDocument(documentAddress) {
    return this.req.post({
      url: "/api/new/document/find-one",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      form: { document: JSON.stringify(documentAddress) },
    });
  }

  getDocuments(documentsAddresses) {
    return this.req.post({
      url: "/api/new/document/find",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      form: { document: JSON.stringify(documentsAddresses) },
    });
  }

  deleteDocument(documentAddress) {
    return this.req.post({
      url: "/api/new/document/remove-one",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      form: { document: JSON.stringify(documentAddress) },
    });
  }
}
